import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const TouchpointSurveys = () => {

    const shouldInitializeTouchpointSurveys = useSelector((state) => state.config.userFeedback.enableTouchpointSurveys);

    const isReadyToInitizalizeTouchpointSurveys = useSelector((state) => state.config.instance.isLoaded && state.auth.isAuthenticated);

    const [hasInitializedTouchpointSurveys, setHasInitializedTouchpointSurveys] = useState(false);

    const touchpointIntegrationKey = useSelector((state) => state.config.userFeedback.touchpointIntegrationKey);
    const productUrl = useSelector((state) => state.config.instance.host);
    const instanceName = useSelector((state) => state.config.instance.instanceName);
    const organization = useSelector((state) => state.config.instance.organizationUniqueToken);
    const userRole = useSelector((state) => state.auth.role);

    useEffect(() => {
        if (shouldInitializeTouchpointSurveys
            && isReadyToInitizalizeTouchpointSurveys
            && !hasInitializedTouchpointSurveys
            && window.Touchpoint
        ) {
            window.Touchpoint?.initialize({
                // Please check documentation for other Touchpoint settings that can be configured
                settings: {
                    containerStyle: {
                        borderRadius: '8px',
                        boxShadow:
                            '0px 3px 5px 0px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)'
                    }
                },
                visitor: {
                    // Pass data points from your site/application to identify the current respondent
                    productUrl: productUrl,
                    instanceName: instanceName,
                    organization: organization,
                    userRole: userRole,
                    productType: 'RD2',
                },
                user_attributes: {
                    // Define attribute data types to be used for targeting.
                    // Dates must be in ISO 8601 format
                    productUrl: 'string',
                    instanceName: 'string',
                    organization: 'string',
                    userRole: 'string',
                    productType: 'string',
                },
                publisher: {
                    // Please do not make edits below
                    app_id: touchpointIntegrationKey,
                    pod: "na2",
                },
            });

            setHasInitializedTouchpointSurveys(true);
        }
    },
        [
            shouldInitializeTouchpointSurveys,
            isReadyToInitizalizeTouchpointSurveys,
            hasInitializedTouchpointSurveys,
        ]
    );

    return null;
}

export default TouchpointSurveys;